import { useEffect, useState } from "react";
import api, { formatApiErrorDetail } from "../../lib/api";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";
import { Input } from "../../components/ui/input";

export default function AdminCoupons() {
  const [coupons, setCoupons] = useState([]);
  const [form, setForm] = useState({ code: "", discount_percent: 10, min_amount: 0 });

  const load = () => api.get("/admin/coupons").then((r) => setCoupons(r.data));
  useEffect(() => { load(); }, []);

  const create = async () => {
    if (!form.code) { toast.error("Enter a code"); return; }
    try {
      await api.post("/admin/coupons", {
        code: form.code, discount_percent: Number(form.discount_percent),
        min_amount: Number(form.min_amount), active: true,
      });
      toast.success("Coupon saved");
      setForm({ code: "", discount_percent: 10, min_amount: 0 });
      load();
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    }
  };

  const del = async (code) => { await api.delete(`/admin/coupons/${code}`); toast.success("Deleted"); load(); };

  return (
    <div data-testid="admin-coupons">
      <h1 className="font-serif text-4xl tracking-tight mb-1">Coupons</h1>
      <p className="text-ink-soft text-sm mb-8">Manage promotional codes</p>

      <div className="grid lg:grid-cols-[1fr_320px] gap-8">
        <div className="border border-line rounded-md overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-black/[0.03] text-left">
              <tr className="overline text-ink-soft">
                <th className="p-4 font-medium">Code</th>
                <th className="p-4 font-medium">Discount</th>
                <th className="p-4 font-medium">Min Order</th>
                <th className="p-4 font-medium text-right">Action</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-line">
              {coupons.map((c) => (
                <tr key={c.code} data-testid={`coupon-${c.code}`}>
                  <td className="p-4 mono">{c.code}</td>
                  <td className="p-4">{c.discount_percent}%</td>
                  <td className="p-4">{c.min_amount ? "₹" + c.min_amount.toLocaleString("en-IN") : "—"}</td>
                  <td className="p-4 text-right"><button onClick={() => del(c.code)} className="p-2 hover:text-red-700"><Trash2 size={15} /></button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="border border-line rounded-md p-6 h-fit">
          <h3 className="font-serif text-2xl mb-5">New coupon</h3>
          <div className="space-y-4">
            <label className="block"><span className="overline text-ink-soft mb-1.5 block">Code</span><Input value={form.code} onChange={(e) => setForm({ ...form, code: e.target.value.toUpperCase() })} data-testid="coupon-code" /></label>
            <label className="block"><span className="overline text-ink-soft mb-1.5 block">Discount %</span><Input type="number" value={form.discount_percent} onChange={(e) => setForm({ ...form, discount_percent: e.target.value })} data-testid="coupon-percent" /></label>
            <label className="block"><span className="overline text-ink-soft mb-1.5 block">Min order (₹)</span><Input type="number" value={form.min_amount} onChange={(e) => setForm({ ...form, min_amount: e.target.value })} /></label>
            <button onClick={create} className="btn-ink w-full py-3 overline flex items-center justify-center gap-2" data-testid="create-coupon-btn"><Plus size={15} /> Create</button>
          </div>
        </div>
      </div>
    </div>
  );
}
